module.exports = __webpack_public_path__ + "img/area-comum-08.d5c83744.png";